/*
 * Copyright (c) 2024 GM Global Technology Operations LLC. All rights reserved.
 * This information is confidential and proprietary to GM Global Technology
 * Operations LLC and may not be used, modified, copied or distributed.
 */

import {
  AfterContentChecked, ChangeDetectorRef, Component, DoCheck, Inject, inject, Input, OnInit, Renderer2, ViewChild,
} from '@angular/core';
import {ActivatedRoute} from '@angular/router';
import { Location } from '@angular/common';
import {APP_CONFIG} from '../app.config';

import {Driver} from "../model/Driver";
import {DriverTraining} from "../model/DriverTraining";
import {DriverDrivingLevel} from "../model/DriverDrivingLevel";
import {DriverEndorsement} from "../model/DriverEndorsement";
import {DriverService} from "../services/driver.service";
import {SitesService} from "../services/sites.service";
import {ViolationDefinitionService} from "../services/violation-definition.service";
import {LocationsService} from "../services/locations.service";
import {LocationTypesService} from "../services/location-types.service";
import {TrainingService} from "../services/training.service";
import {EndorsementService} from "../services/endorsement.service";
import {DrivingLevelsService} from "../services/driving-levels.service";
import {AccidentsService} from "../services/accidents.service";
import {DriverViolation} from "../model/DriverViolation";
import {NgxSpinnerService} from 'ngx-spinner';
import { DriverGovernmentEndorsement } from '../model/DriverGovernmentEndorsement';
import { RegionService } from '../services/region.service';
import { GovermentEndorsementsService } from '../services/goverment-endorsements.service';
import {EmployeeTypeService} from "../services/employee-type.service";
import {EcsUploadDownloadService} from "../services/ecs-upload-download.service";
import {HttpEventType,HttpResponse} from "@angular/common/http";
import {Attachment} from "../model/attachment";
import { LicenseTypeService } from '../services/license-type.service';
import {Site} from "../model/Site";
import {BaseMessageComponent} from '../common/base-message.component';

declare var $:any;

@Component({
    selector: 'app-driver-detail',
    templateUrl: './driver-detail.component.html',
    styleUrls: ['./driver-detail.component.less'],
    standalone: false
})

export class DriverDetailComponent extends BaseMessageComponent implements OnInit, DoCheck, AfterContentChecked {

  @ViewChild('mainBody') driverDetailForm: any;
  trainingsites = [];
  levelsites = [];
  endorsementsites = [];
  regions = [];
  violationsites =[];
  accidents =[];
  courses= [];
  endorsements=[];
  govEndorsements = [];
  licenseTypes = [];
  employeeTypes =[];

  drivingLevels=[];
  violationDefinitions=[];
  locations=[];
  locationTypes=[];
  MasterViolationLocations=[];

  violationComment="";
  modalForAttachment = false;
  fileToUpload:File=null;

  lastStepValidated = true;
  totalViolationPoints =0;

  isSuperAdmin = (sessionStorage.getItem("isSuperAdmin")=="true");
  isEditable = (sessionStorage.getItem("isSiteAdmin") === "true");

  // Restrict accident/violation API calls to admin roles.
  private get canAccessRestrictedSafetyApis(): boolean {
    return this.isSuperAdmin || this.isEditable;
  }

  availableRoles = sessionStorage?.getItem('siteAdminRoles')?.split(',');
  availableSites=[];
  originalSiteId=0;

  public urlDriverID = +this.route.snapshot?.paramMap?.get('id');
  private readonly reportUrls: {};
  private readonly powerBiUrl: string;

  constructor(
    private renderer: Renderer2,
    private driverService: DriverService,
    private employeeTypeService: EmployeeTypeService,
    private siteService: SitesService,
    private regionService: RegionService,
    private trainingService: TrainingService,
    private endorsementService: EndorsementService,
    private governmentEndorsementService: GovermentEndorsementsService,
    private licenseTypeService: LicenseTypeService,
    private drivingLevelService: DrivingLevelsService,
    private violationDefinitionService: ViolationDefinitionService,
    private locationService: LocationsService,
    private locationTypeService: LocationTypesService,
    private accidentService: AccidentsService,
    private route: ActivatedRoute,
    private location: Location,
    private ecsUploadDownloadService: EcsUploadDownloadService,
    private spinnerService: NgxSpinnerService,
    cdr: ChangeDetectorRef,
    @Inject(APP_CONFIG) appConfig: any) {
    super(cdr);
    this.powerBiUrl = appConfig.powerBiUrl;
    this.reportUrls = appConfig.reportUrls;
  }

  @Input() driver: Driver;
  @Input() driverEndorsement: DriverEndorsement[]=[];
  driverGovernmentEndorsements: DriverGovernmentEndorsement[] = [];
  @Input() driverDrivingLevel: DriverDrivingLevel[]=[];
  @Input() driverTraining: DriverTraining[]=[];
  @Input() driverViolation: DriverViolation[]=[];

  ngOnInit() {
    if (this.isSuperAdmin)
      this.isEditable=true;
    if (this.urlDriverID==0)
    {
      this.driver= new Driver;
      this.driver.driverID=0;
      this.driver.status_id=1;
      this.doLookupFields('employeetypes');
    }
    this.getDriver();
  }

  ngDoCheck():void{

  }



  ngAfterContentChecked(){
    // disabled all fields if user is not an administrator
    this.disabledEnabledElements(this.isEditable,"*", document.querySelector('#mainBody'));
    document.getElementsByClassName('row showcase-body')[0]?.setAttribute('style','height:100%');

    if (!this.isEditable && document.getElementById('SaveChange')) {
      document.getElementById('SaveChange').outerHTML = '';
      document.getElementById('ResetChange').outerHTML = '';
    }
    if (this.driver && this.driver.status_id!=2)
      this._setTotalViolationPoints();
  }


  trackByIndex(index:number, obj:any):any {
    if (document.getElementById('training_dateInput'+index)) {
      let parent = document.getElementById('training_dateInput' + index);
    }
    return index;
  }


  getDriver(): void {
    if (this.urlDriverID!=undefined && this.urlDriverID!=0) {
      this.spinnerService.show();
      this.driverService.getDriver(this.urlDriverID)
        .subscribe(driver => {
          this.driver = driver;
          this.cdr.detectChanges();
          if(driver.driverID)
          {// only we found a driver, otherwise no brother to get other infos.
            this.driverService.getDriverEndorsement(this.urlDriverID).subscribe(driverEndorsement => {
              this.driverEndorsement = driverEndorsement;
              this.cdr.detectChanges();
            });
            this.driverService.getDriverGovernmentEndorsement(this.urlDriverID).subscribe(driverGovernmentEndorsements => {
              this.driverGovernmentEndorsements = driverGovernmentEndorsements;
              this.cdr.detectChanges();
            });
            this.driverService.getDrivingLevel(this.urlDriverID).subscribe(driverDrivingLevel => {
              this.driverDrivingLevel = driverDrivingLevel;
              this.cdr.detectChanges();
            });
            if (this.canAccessRestrictedSafetyApis) {
              this._getDriverAccidents();
              this._getDriverViolations();
            } else {
              this.accidents = [];
              this.driverViolation = [];
            }
            this.driverService.getDriverTraining(this.urlDriverID).subscribe(driverTraining => {
              this.driverTraining = driverTraining;
              setTimeout(()=>{
                this.spinnerService.hide();
                this._markFormPristine(this.driverDetailForm);
                this.cdr.detectChanges();
              },1000);
            });
            this.doLookupFields('employeetypes');
            this.doLookupFields('trainingsites');
            this.doLookupFields('levelsites');
            this.doLookupFields('endorsementsites');
            this.doLookupFields('regions');
            this.doLookupFields('violationsites');
            this.doLookupFields('course');
            this.doLookupFields('endorsement');
            this.doLookupFields('govEndorsement');
            this.doLookupFields('licenseTypes');
            this.doLookupFields('drivinglevel');
            this.doLookupFields('violationDefinitions');
            this.doLookupFields('locationTypes');

          }
          else
            this.spinnerService.hide();
        });

    }
  }

  private _getDriverViolations(): void{
    if (!this.canAccessRestrictedSafetyApis) {
      this.driverViolation = [];
      this.MasterViolationLocations = [];
      return;
    }

    this.MasterViolationLocations=[];
    var tempArray=[];
    this.driverService.getDriverViolation(this.urlDriverID).subscribe(driverViolation => {
      this.driverViolation = driverViolation;
      this.cdr.detectChanges();
      this.driverViolation.forEach(vl=>{
        vl.fakeViolationTime = vl.violationTime.substr(0,5);
        this.siteService.getLocationsBySiteId(vl.siteId).subscribe(locs=>{
          vl.locationTypeId = locs.find(ml=>ml.locationId==vl.locationId).locationTypeId;
          this.locationService.search(vl.siteId,vl.locationTypeId).subscribe(res=>{
            res.forEach(r=>{r.violationId=vl.violationId});
            tempArray.push(res);
          });
        });
      });

      this._buildLocationArray(this.driverViolation,tempArray, driverViolation.length);
    });
  }

  private _getDriverAccidents(): void {
    if (!this.canAccessRestrictedSafetyApis) {
      this.accidents = [];
      return;
    }

    this.accidentService.getAccidentsByDriver(this.urlDriverID).subscribe(accidents=>{
      this.accidents = accidents;
      this.cdr.detectChanges();
      if (this.accidents!=undefined && this.accidents.length>0) {
        this.accidents.forEach(a => {
          this.locationService.getLocationById(a.locationId).subscribe(loc => {
            a.siteName = loc.siteName;
            this.locationTypeService.getLocationType(loc.locationTypeId).subscribe(locType => {
              a.locationTypeName = locType.locationType;
              this.cdr.detectChanges();
            });
          });
        });
      }
    });
  }

  private _buildLocationArray(driverVioloation: DriverViolation[], tempArray: Array<any>, totalSize:number){
    if (tempArray.length<totalSize)
      setTimeout(()=>{ this._buildLocationArray(this.driverViolation,tempArray, totalSize);},20);
    else {

      driverVioloation.forEach(x => {
        for (let v=0; v< totalSize; v++){
          if (tempArray[v][0].violationId==x.violationId){
            this.MasterViolationLocations.push(tempArray[v]);
          }
        }

      });
      this.cdr.detectChanges();
    }
  }

  OpenModal(comment:string, index:number,forAttachment:boolean=false, type:string='', fileId:number=0){
    this.modalForAttachment = forAttachment;
    $('#ViolationModal').modal('show');
    this.violationComment = comment;
    $('#hiddenCommentIndex').attr('index',index);

    $('#hiddenCommentIndex').attr('filetype', type);
    $('#hiddenCommentIndex').attr('fileid', fileId);

  }

  CloseModal(){
    $('#ViolationModal').modal('hide');
  }

  SaveComment(){
    $('#ViolationModal').modal('hide');
    let index = $('#hiddenCommentIndex').attr('index');
    this.driverViolation[index].violationComment = this.violationComment;
    this.driverViolation[index].commentBeChanged=true;
  }

  downloadAttachmentFile(remoteFilePath:string){
    this.ecsUploadDownloadService.downloadAttachment(remoteFilePath);
  }
  handleFileInput(files: FileList) {
    this.fileToUpload = files.item(0);
  }

  UploadFile(files: FileList){
    $('#uploading').attr("style"," color: darkred; font-weight: bold");
    var type = $('#hiddenCommentIndex').attr('filetype');
    var fileId = $('#hiddenCommentIndex').attr('fileid');
    let index = $('#hiddenCommentIndex').attr('index');
    this.ecsUploadDownloadService.uploadAttachmentMultipart(type,fileId,this.fileToUpload).subscribe(event=>{
      if (event.type === HttpEventType.UploadProgress) {
      } else if (event instanceof HttpResponse) {
        $('#ViolationModal').modal('hide');
        let fileName = event.body.toString().replace(type+"/","").replace(fileId+"/","");
        let attachment = new Attachment();
        attachment.attachmentUrl = type +"/" + fileId.toString()+"?objectID="+fileName;
        switch(type) {
          case 'violations': {
            this.driverViolation.find(v => v.violationId == fileId).attachment = attachment.attachmentUrl;
            this.driverService.updateAttachmentById(this.driver.driverID,type,fileId,attachment).subscribe(x=>{
              $('#violation_attachment_upload'+index).removeClass("btn btn-xs btn-secondary btn-group").addClass("btn btn-xs btn-hasContent btn-group");
            });
            break;
          }
          case 'drivertrainings': {
            this.driverTraining.find(v => v.driverTrainingId == fileId).attachment = attachment.attachmentUrl;
            this.driverService.updateAttachmentById(this.driver.driverID,type,fileId,attachment).subscribe(x=> {
              $('#drtraining_attachment_upload' + index).removeClass("btn btn-xs btn-secondary btn-group").addClass("btn btn-xs btn-hasContent btn-group");
            });
            break;
          }
          case 'driverlevels': {
            this.driverDrivingLevel.find(v => v.driverDrivingLevelId == fileId).attachment = attachment.attachmentUrl;
            this.driverService.updateAttachmentById(this.driver.driverID,type,fileId,attachment).subscribe(x=> {
              $('#level_attachment_upload' + index).removeClass("btn btn-xs btn-secondary btn-group").addClass("btn btn-xs btn-hasContent btn-group");
            });
            break;
          }
          case 'driverendorsements': {
            this.driverEndorsement.find(v => v.driverEndorsementId == fileId).attachment = attachment.attachmentUrl;
            this.driverService.updateAttachmentById(this.driver.driverID,type,fileId,attachment).subscribe(x=> {
              $('#endorsement_attachment_upload' + index).removeClass("btn btn-xs btn-secondary btn-group").addClass("btn btn-xs btn-hasContent btn-group");
            });
            break;
          }
          case 'accidents': {
            this.accidents.find(v => v.accidentId == fileId).attachment = attachment.attachmentUrl;
            this.accidentService.updateAccidentAttachmentById(fileId,attachment).subscribe(x=>{
              $('#accident_attachment_upload'+index).removeClass("btn btn-xs btn-secondary btn-group").addClass("btn btn-xs btn-hasContent btn-group");
            });
            break;
          }
        }
      }
    },(err) => {
      $('#uploading').attr("style","display:none;");
      if (err.message!=null && err.message=='Http failure response for (unknown url): 0 Unknown Error')
        alert("Attachment size exceeds the allowable limit!");
      else{
        alert(JSON.parse(err.error).message);
      }
    },()=>{
      $('#uploading').attr("style","display:none");
    });
  }

  redirectToAccidents(accidentId:number=-1, personId:number=-1){
    if (accidentId>0 && personId>0)
      window.location.href="#/accidentDetail/person/"+ this.driver.personID + "/accident/"+ accidentId;
    else
      window.location.href="#/accidentDetail";
  }

  SaveDriver()
  {
    let driver : Driver = this.driver;
    if (this.driver.driverID==0)
    {
      //brand new driver skipp all update routines
      this.driverService.AddDriverInfo(driver).subscribe(value => {
          window.location.href="#/driverDetail/"+ value.driverID;
        }, (error) => {
          //failed
          this.returnMessage = 'Adding Driver return error: ' + error.status;
          setTimeout(() => {
            this.returnMessage = '';
          }, 2000);
        },
        () => {
        })
    }
    else {
      this.driverService.UpdateDriverInfo(driver).subscribe(value => {
          console.log(driver + " saved.")
        }, (error) => {
          //failed
          this.returnMessage = 'Updating Driver return error: ' + error.status;
          setTimeout(() => {
            this.returnMessage = '';
          }, 2000);
        },
        () => {
          this.returnMessage = 'Updating Driver finished';
          setTimeout(() => {
            this.returnMessage = '';
          }, 2000);
        });

      // training portion
      this.driverTraining.forEach(x => {
        if (x.driverTrainingId == null) {
          //new training
          this.driverService.AddDriverTraining(x).subscribe(value => {
              console.log(x + " saved");
              this.driverTraining.find(dt=>dt==x).driverTrainingId = value.driverTrainingId;
              this.cdr.detectChanges();
            }, (error) => {
              //failed
              this.returnMessage = 'Updating Driver Trainng return error: ' + error.status;
              setTimeout(() => {
                this.returnMessage = '';
              }, 2000);
              this.spinnerService.hide();
            },
            () => {
              this.spinnerService.hide();
              this.returnMessage = 'Updating Driver Training finished';
              setTimeout(() => {
                this.returnMessage = '';
              }, 2000);
            });
        }
        else if (x.driverTrainingId != null && x.driverTrainingId >0) {
          //do the update training part
          x.driverId = this.urlDriverID;
          this.driverService.UpdateDriverTraining(x).subscribe(value => {
              x = value;
              console.log(driver + " training saved.")
            }, (error) => {
              //failed
              this.returnMessage = 'Updating Driving Training return error: ' + error.status;
              setTimeout(() => {
                this.returnMessage = '';
              }, 2000);
            },
            () => {
              //this.loading = false;
              this.returnMessage = 'Updating Driving Training finished';
              setTimeout(() => {
                this.returnMessage = '';
              }, 2000);
            });
        }
        else if (x.driverTrainingId != null && x.driverTrainingId <0) {
          //delete driving training
          var y = Object.create(x);

          y.driverTrainingId = (0-y.driverTrainingId);
          this.driverService.getDriverTraining(this.urlDriverID).subscribe(dv=>{
            var isExist = dv.find(edv=>edv.driverTrainingId===y.driverTrainingId);
            if (isExist) {
              this.driverService.DeleteDriverTraining(y).subscribe(value => {
              }, (error) => {
                //failed
                this.returnMessage = 'Deleting driver training return error: ' + error.status;
                setTimeout(() => {
                  this.returnMessage = '';
                }, 2000);
              }, () => {
                this.returnMessage = 'Deleting Driver Traning finished';
                setTimeout(() => {
                  this.returnMessage = '';
                }, 2000);
              });
            }
          });
        }
      });

      // driving level portion
      this.driverDrivingLevel.forEach(x => {
        if (x.driverDrivingLevelId == null) {
          //new level
          this.driverService.AddDrivingLevel(x).subscribe(value => {
              this.driverDrivingLevel.find(dt=>dt==x).driverDrivingLevelId = value.driverDrivingLevelId;
              this.cdr.detectChanges();
            }, (error) => {
              //failed
              this.returnMessage = 'Updating Driver Level return error: ' + error.status;
              setTimeout(() => {
                this.returnMessage = '';
              }, 2000);
              this.spinnerService.hide();
            },
            () => {
              this.spinnerService.hide();
              this.returnMessage = 'Adding Driver Level finished';
              setTimeout(() => {
                this.returnMessage = '';
              }, 2000);
            });
        }
        else if (x.driverDrivingLevelId != null && x.driverDrivingLevelId >0) {
          //do the update level part
          x.driverId = this.urlDriverID;
          this.driverService.UpdateDrivingLevel(x).subscribe(value => {
              console.log(driver + " saved.")
            }, (error) => {
              //failed
              this.returnMessage = 'Updating Driving Level return error: ' + error.status;
              setTimeout(() => {
                this.returnMessage = '';
              }, 2000);
            },
            () => {

              this.returnMessage = 'Updating Driving Level finished';
              setTimeout(() => {
                this.returnMessage = '';
              }, 2000);
            });
        }
        else if (x.driverDrivingLevelId != null && x.driverDrivingLevelId <0) {
          //delete driving level
          var y = Object.create(x);

          y.driverDrivingLevelId = (0-y.driverDrivingLevelId);
          this.driverService.getDrivingLevel(this.urlDriverID).subscribe(dv=>{
            var isExist = dv.find(edv=>edv.driverDrivingLevelId===y.driverDrivingLevelId);
            if (isExist) {
              this.driverService.DeleteDrivingLevel(y).subscribe(value => {
              }, (error) => {
                //failed
                this.returnMessage = 'Deleting driver Level return error: ' + error.status;
                setTimeout(() => {
                  this.returnMessage = '';
                }, 2000);
              }, () => {
                this.returnMessage = 'Deleting Driver Level finished';
                setTimeout(() => {
                  this.returnMessage = '';
                }, 2000);
              });
            }
          });
        }
      });

      // driving endorsement portion
      this.driverEndorsement.forEach(x => {
        if (x.driverEndorsementId == null) {
          //new endorsement
          this.driverService.AddDriverEndorsement(x).subscribe(value => {
              this.driverEndorsement.find(dt=>dt==x).driverEndorsementId = value?.driverEndorsementId;
              this.cdr.detectChanges();
            }, (error) => {
              //failed
              this.returnMessage = 'Updating Driver Level return error: ' + error.status;
              setTimeout(() => {
                this.returnMessage = '';
              }, 2000);
              this.spinnerService.hide();
            },
            () => {
              this.spinnerService.hide();
              this.returnMessage = 'Adding Driver Endorsement finished';
              setTimeout(() => {
                this.returnMessage = '';
              }, 2000);
            });
        }
        else if (x.driverEndorsementId != null && x.driverEndorsementId >0) {
          // do the update endorsement part
          x.driverId = this.urlDriverID;
          this.driverService.UpdateDriverEndorsement(x).subscribe(value => {
              console.log(x + " saved")
            }, (error) => {
              //failed
              this.returnMessage = 'Updating Driver Endorsement return error: ' + error.status;
              setTimeout(() => {
                this.returnMessage = '';
              }, 2000);
              this.spinnerService.hide();
            },
            () => {
              this.spinnerService.hide();
              this.returnMessage = 'Updating Driver Endorsement finished';
              setTimeout(() => {
                this.returnMessage = '';
              }, 2000);
            });
        }
        else if (x.driverEndorsementId != null && x.driverEndorsementId <0) {
          //delete driving endorsement
          var y = Object.create(x);

          y.driverEndorsementId = (0-y.driverEndorsementId);
          this.driverService.getDriverEndorsement(this.urlDriverID).subscribe(dv=>{
            var isExist = dv.find(edv=>edv.driverEndorsementId===y.driverEndorsementId);
            if (isExist) {
              this.driverService.DeleteDriverEndorsement(y).subscribe(value => {
              }, (error) => {
                //failed
                this.returnMessage = 'Deleting driver endorsement return error: ' + error.status;
                setTimeout(() => {
                  this.returnMessage = '';
                }, 2000);
              }, () => {
                this.returnMessage = 'Deleting Driver endorsement finished';
                setTimeout(() => {
                  this.returnMessage = '';
                }, 2000);
              });
            }
          });
        }
      });

      // gov driving endorsement portion
      if(this.driverGovernmentEndorsements!=null)
      {
        this.driverGovernmentEndorsements.forEach(x => {
          if (x.driverGovernmentEndorsementId == null) {
            //new endorsement
            this.driverService.AddDriverGovernmentEndorsement(x).subscribe(value => {
                this.driverGovernmentEndorsements.find(dt=>dt==x).driverGovernmentEndorsementId = value.driverGovernmentEndorsementId;
                this.cdr.detectChanges();
                console.log(JSON.stringify(x) + " saved")
              }, (error) => {
                //failed
                this.returnMessage = 'Updating Government Endorsement return error: ' + error.status;
                setTimeout(() => {
                  this.returnMessage = '';
                }, 2000);
                this.spinnerService.hide();
              },
              () => {
                this.spinnerService.hide();
                this.returnMessage = 'Adding Government Endorsement finished';
                setTimeout(() => {
                  this.returnMessage = '';
                }, 2000);
              });
          } else if (x.driverGovernmentEndorsementId != null && x.driverGovernmentEndorsementId >0) {
            // do the update endorsement part
            x.driverId = this.urlDriverID;
            this.driverService.UpdateDriverGovernmentEndorsement(x).subscribe(value => {
                console.log(x + " saved")
              }, (error) => {
                //failed
                this.returnMessage = 'Updating Driver Government Endorsement return error: ' + error.status;
                setTimeout(() => {
                  this.returnMessage = '';
                }, 2000);
                this.spinnerService.hide();
              },
              () => {
                this.spinnerService.hide();
                this.returnMessage = 'Updating Driver Government Endorsement finished';
                setTimeout(() => {
                  this.returnMessage = '';
                }, 2000);
              });
          }
          else if (x.driverGovernmentEndorsementId != null && x.driverGovernmentEndorsementId <0) {
            //delete driving endorsement
            var y = Object.create(x);
            y.driverGovernmentEndorsementId = (0-y.driverGovernmentEndorsementId);
            this.driverService.getDriverGovernmentEndorsement(this.urlDriverID).subscribe(dv=>{
              var isExist = dv.find(edv=>edv.driverGovernmentEndorsementId===y.driverGovernmentEndorsementId);
              if (isExist) {
                this.driverService.DeleteDriverGovernmentEndorsement(y).subscribe(value => {
                }, (error) => {
                  //failed
                  this.returnMessage = 'Deleting driver Gov. endorsement return error: ' + error.status;
                  setTimeout(() => {
                    this.returnMessage = '';
                  }, 2000);
                }, () => {
                  this.returnMessage = 'Deleting Driver Gov. endorsement finished';
                  setTimeout(() => {
                    this.returnMessage = '';
                  }, 2000);
                });
              }
            });
          }
        });
      }

      // driver violation portion
      if (this.canAccessRestrictedSafetyApis) {
        this.driverViolation.forEach(x => {
          if (x.violationId == null) {
            //new violation
            x.violationTime = x.fakeViolationTime + ":00";
            let _Date = x.violationDate.toString();
            if(this.lastStepValidated)
              this._checkHasSameViolation(x, this.driverViolation);

            if(this.lastStepValidated) {
              this.driverService.AddDriverViolation(x).subscribe(value => {
                  this.driverViolation.find(dt => dt == x).violationId = value.violationId;
                  x.fakeViolationTime = x.violationTime.substr(0, 5);
                  console.log(x + " saved");
                  this.cdr.detectChanges();
                }, (error) => {
                  //failed
                  this.returnMessage = 'Updating Driver Violation return error: ' + error;
                  setTimeout(() => {
                    this.returnMessage = '';
                  }, 2000);
                  this.spinnerService.hide();
                },
                () => {
                  this.spinnerService.hide();
                  this.returnMessage = 'Adding Driver Violation finished';
                  setTimeout(() => {
                    this.returnMessage = '';
                  }, 2000);
                });
            }
          }
          else if (x.violationId != null && x.violationDefinitionId >0) {
            // do the update driver violation part
            x.violationTime = x.fakeViolationTime + ":00";
            let _Date = x.violationDate.toString();
            if(this.lastStepValidated)
              this._checkHasSameViolation(x, this.driverViolation);

            if(this.lastStepValidated) {
              x.driverId = this.urlDriverID;
              this.driverService.UpdateDriverViolation(x).subscribe(value => {
                  x.fakeViolationTime = x.violationTime.substr(0, 5);
                  console.log(x + " saved");
                }, (error) => {
                  //failed
                  this.returnMessage = 'Updating Driver Violation return error: ' + error.status;
                  setTimeout(() => {
                    this.returnMessage = '';
                  }, 2000);
                  this.spinnerService.hide();
                },
                () => {
                  this.spinnerService.hide();
                  this.returnMessage = 'Updating Driver Violation finished';
                  setTimeout(() => {
                    this.returnMessage = '';
                  }, 2000);
                });
            }
          }
          else if (x.violationId != null && x.violationDefinitionId <0) {
            //delete driver violation
            var y = Object.create(x);
            y.violationDefinitionId = (0-y.violationDefinitionId);
            this.driverService.getDriverViolation(this.urlDriverID).subscribe(dv=>{
              var isExist = dv.find(edv=>edv.violationId===y.violationId);
              if (isExist){
                this.driverService.DeleteDriverViolation(y).subscribe(value=>{},(error)=>{
                  //failed
                  this.returnMessage = 'Deleting driver violation return error: ' + error.status;
                  setTimeout(() => {
                    this.returnMessage = '';
                  }, 2000);
                },()=>{
                  this.returnMessage = 'Deleting driver violation finished';
                  setTimeout(() => {
                    this.returnMessage = '';
                  }, 2000);
                });
              }
            });
          }
        });
      }

      // driver accident portion
      if (this.canAccessRestrictedSafetyApis && this.accidents!=undefined) {
        this.accidents.forEach(x => {
          if (x.accidentId != null && x.accidentId < 0) {
            var y = Object.create(x);
            y.accidentId = (0 - y.accidentId);
            this.accidentService.getAccidentsByDriver(this.urlDriverID).subscribe(a=>{
              var isExist = a.find(ea=>ea.accidentId===y.accidentId);
              if (isExist) {
                this.accidentService.deleteAccidentById(y).subscribe(value => {
                }, (error) => {
                  //failed
                  this.returnMessage = 'Deleting driver accident return error: ' + error.status;
                  setTimeout(() => {
                    this.returnMessage = '';
                  }, 2000);
                }, () => {
                  this.returnMessage = 'Deleting driver accident finished';
                  setTimeout(() => {
                    this.returnMessage = '';
                  }, 2000);
                });
              }
            });
          }
        });
      }

      if (this.lastStepValidated)
        setTimeout(()=>{
          this._markFormPristine(this.driverDetailForm);
        },700);
      else
        this.lastStepValidated=true;
    }

  }

  private _add_Years(dt,n){
    return new Date(dt.setFullYear(dt.getFullYear() + n));
  }

  private _checkHasSameViolation(x: DriverViolation, arrayViolations: DriverViolation[]){
    var vDate = new Date(x.violationDate);
    var d = vDate.getDate();
    var m= vDate.getMonth();
    var y = vDate.getFullYear();

    var foundDV = arrayViolations.filter(el=>{
      return new Date(el.violationDate).getFullYear()==y && new Date(el.violationDate).getMonth()==m && new Date(el.violationDate).getDate()==d && el.violationTime==x.violationTime && el.violationDefinitionId== x.violationDefinitionId
    });
    if (foundDV.length>1){
      alert('There are two of more violations have same ( Date | Time | Classification), please fix this then save again.');
      this.lastStepValidated=false;
    }
    else
      this.lastStepValidated=true;
  }

  private _markFormPristine(form): void {
    Object.keys(form.controls).forEach(control => {
      form.controls[control].markAsPristine();
    });

    this.driverViolation.forEach(x=>x.commentBeChanged=null);

    $.each($('gm-datepicker span'),function (index,value) {
      $(this).hasClass('ng-touched');
      $(this).removeClass('ng-touched').addClass("ng-untouch");
    });

    $.each($('*[id*=attachment_upload]'), function(index,value){
      if ($(this).hasClass('btn btn-xs btn-hasContent btn-group'))
        $(this).removeClass().addClass("btn btn-xs btn-secondary btn-group");
    });

    $.each($('*[id*=attachment_download]'), function(index,value){
      if ($(this).hasClass('btn btn-xs btn-secondary btn-group btn-primary'))
        $(this).attr('disabled','disabled');
    });
  }

  ReloadFromLDAP(driverID){
    this.spinnerService.show();
    this._emptyDriverInfoFields(driverID);
    this.doLookupFields('employeetypes');
    this.driverService.getDriverFromLDAP(this.urlDriverID).subscribe(driver => {
      if (driver) {
        this.driver = driver;
      } else {
        // Handle the null case, e.g., show an error message or set a default value
        console.error('Driver not found');
        this.driver = new Driver(); // or any other default handling
      }
      this.cdr.detectChanges();
    },(error)=>{
      this.spinnerService.hide();
    },()=>{
      this.spinnerService.hide();
    });
  }

  ResetDriverInfo(driverID){
    this._emptyDriverInfoFields(driverID);
    this.doLookupFields('employeetypes');
    this.driverService.getDriver(this.urlDriverID).subscribe(driver => {
      this.driver = driver;
      this.cdr.detectChanges();
    });
  }

  private _emptyDriverInfoFields(driverID)
  {
    this.driver.driverID=driverID;
    this.driver.comment=null;
    this.driver.identificationId=null;
    this.driver.status_id=1;
    this.driver.preferredName=null;
    this.driver.phoneNumber=null;
    this.driver.email=null;
    this.driver.lastName=null;
    this.driver.firstName=null;
    this.driver.namePrefix=null;
    this.driver.employeeTypeId=null;
    this.driver.ratingScore=null;
    this.driver.company=null;
  }

  OpenReport() {
    let driverInfoAdminUrl = " "
    if(this.isEditable || this.isSuperAdmin) {
      driverInfoAdminUrl = this.reportUrls["DriverInfoAdmin"];
    }
    let url = this.powerBiUrl + driverInfoAdminUrl + "&rp:DRV_ID=" + this.driver.driverID;
    window.open(url, '_blank');
  }

  AddTraining(tableRef)
  {
    let newTraining  = new DriverTraining();
    newTraining.driverId = this.driver.driverID;
    newTraining.driverTrainingId=null;
    newTraining.completeDate=new Date(Date.now()).toJSON();
    newTraining.expirationDate=null;
    newTraining.attachment=null;
    newTraining.siteId=null;
    newTraining.courseNumber=null;
    newTraining.courseName=null;
    newTraining.trainingCourseId=null;
    this.driverTraining.push(newTraining);
    this.cdr.detectChanges();

    setTimeout(()=>{this.disabledEnabledElements(this.isEditable,"*", document.querySelector('#tableTraining'));},50);
  }

  deleteTraining(trainingID: number, index: number)
  {
    var row =document.querySelector('#training_course_name_'+index.toString()).parentElement.parentElement;
    row.setAttribute('style','display:none');
    row.setAttribute('deleted','1');

    this.driverTraining[index].completeDate=new Date(Date.now()).toJSON();
    this.driverTraining[index].expirationDate=new Date(Date.now()).toJSON();
    this.driverTraining[index].siteId=0;
    this.driverTraining[index].trainingCourseId=0;
    this.driverTraining[index].courseNumber='0';
    this.driverTraining[index].courseName='0';
    this.driverTraining[index].driverTrainingId=(0-trainingID);
  }

  ResetTraining(tableRef)
  {
    this.driverTraining=[];
    this.driverService.getDriverTraining(this.urlDriverID).subscribe(driverTraining => {
      this.driverTraining = driverTraining;
      this.cdr.detectChanges();
    });

  }
// training Level portion
  AddLevel(tableRef)
  {
    let newLevel  = new DriverDrivingLevel;
    newLevel.driverId= this.driver.driverID;
    newLevel.attachment=null;
    newLevel.campusDrivingPermitNumber=null;
    newLevel.driverDrivingLevelId=null;
    newLevel.drivingLevelDesc=null;
    newLevel.drivingLevelId=null;
    newLevel.drivingLevelName=null;
    newLevel.expirationDate=null;
    newLevel.provingGroundLicenseNumber=null;
    newLevel.siteId=null;
    newLevel.siteName=null;
    newLevel.trainingDate=new Date(Date.now()).toJSON();
    this.driverDrivingLevel.push(newLevel);
    this.cdr.detectChanges();

    setTimeout(()=>{this.disabledEnabledElements(this.isEditable,"*", document.querySelector('#tableLevel'));},50);
  }

  deleteLevel(levelID: number, index: number)
  {
    var row =document.querySelector('#driver_level'+index.toString()).parentElement.parentElement;
    row.setAttribute('style','display:none');
    row.setAttribute('deleted','1');

    this.driverDrivingLevel[index].driverDrivingLevelId=(0-levelID);
    this.driverDrivingLevel[index].drivingLevelId=0;
    this.driverDrivingLevel[index].expirationDate=new Date(Date.now()).toJSON();
    this.driverDrivingLevel[index].siteId=0;
    this.driverDrivingLevel[index].trainingDate=new Date(Date.now()).toJSON();
    this.driverDrivingLevel[index].drivingLevelId=0;
  }

  Resetlevel(tableRef)
  {
    this.driverDrivingLevel=[];
    this.driverService.getDrivingLevel(this.urlDriverID).subscribe(drivingLevel => {
      this.driverDrivingLevel = drivingLevel;
      this.cdr.detectChanges();
    });

  }


  // Endorsement portion
  AddEndorsement(tableRef)
  {
    let newEndorsement  = new DriverEndorsement();
    newEndorsement.driverId = this.driver.driverID;
    newEndorsement.attachment=null;
    newEndorsement.driverEndorsementId=null;
    newEndorsement.expirationDate=null;
    newEndorsement.dateValidated=new Date(Date.now()).toJSON();
    newEndorsement.siteId=null;
    newEndorsement.siteName=null;
    newEndorsement.endorsementId=null;
    newEndorsement.endorsementName = null;
    newEndorsement.endorsementDesc = null;

    this.driverEndorsement.push(newEndorsement);
    this.cdr.detectChanges();

    setTimeout(()=>{this.disabledEnabledElements(this.isEditable,"*", document.querySelector('#tableEndorsement'));},50);
  }

  deleteEndorsement(endorsementID: number, index: number)
  {
    var row =document.querySelector('#endorsement'+index.toString()).parentElement.parentElement;
    row.setAttribute('style','display:none');
    row.setAttribute('deleted','1');

    this.driverEndorsement[index].expirationDate = new Date(Date.now()).toJSON();
    this.driverEndorsement[index].dateValidated=new Date(Date.now()).toJSON();
    this.driverEndorsement[index].siteId=0;
    this.driverEndorsement[index].endorsementId=0;
    this.driverEndorsement[index].driverEndorsementId=(0-endorsementID);
  }

  ResetEndorsement(tableRef)
  {
    this.driverEndorsement=[];
    this.driverService.getDriverEndorsement(this.urlDriverID).subscribe(driverEndorsement => {
      this.driverEndorsement = driverEndorsement;
      this.cdr.detectChanges();
    });
  }

  //Government License/Endorsement portion
  addGovernmentEndorsement(tableRef) {
    if (!this.driverGovernmentEndorsements) {
      this.driverGovernmentEndorsements = [];
    }
    let newEndorsement  = new DriverGovernmentEndorsement();
    newEndorsement.driverId = this.driver.driverID;
    newEndorsement.governmentEndorsementId = null;
    newEndorsement.expirationDate = null;
    newEndorsement.dateValidated=new Date(Date.now()).toJSON();
    newEndorsement.regionId = null;
    newEndorsement.regionName = null;
    newEndorsement.governmentEndorsementId=null;
    newEndorsement.endorsementName = null;

    this.driverGovernmentEndorsements.push(newEndorsement);
    this.cdr.detectChanges();

    setTimeout(()=>{this.disabledEnabledElements(this.isEditable,"*", document.querySelector('#tableGovLicense'));},50);
  }

  deleteGovernmentEndorsement(govEndorsementID: number, index: number) {
    var row =document.querySelector('#governmentEndorsement'+index.toString()).parentElement.parentElement;
    row.setAttribute('style','display:none');
    row.setAttribute('deleted','1');

    this.driverGovernmentEndorsements[index].expirationDate = new Date(Date.now()).toJSON();
    this.driverGovernmentEndorsements[index].dateValidated=new Date(Date.now()).toJSON();
    this.driverGovernmentEndorsements[index].regionId = 0;
    this.driverGovernmentEndorsements[index].governmentEndorsementId=0;
    this.driverGovernmentEndorsements[index].driverGovernmentEndorsementId=(0-govEndorsementID);
  }

  resetGovernmentEndorsement(tableRef) {
    this.driverGovernmentEndorsements=[];
    this.driverService.getDriverGovernmentEndorsement(this.urlDriverID).subscribe(driverGovernmentEndorsements => {
      this.driverGovernmentEndorsements = driverGovernmentEndorsements;
      this.cdr.detectChanges();
    });
  }


  // Violations portion
  AddViolation(tableRef)
  {
    let newViolation  = new DriverViolation();
    newViolation.driverId= this.driver.driverID;
    newViolation.attachment=null;
    newViolation.violationDate=null;
    newViolation.violationTime=null;
    newViolation.fakeViolationTime=null;
    newViolation.violationArea=null;
    newViolation.pointsExpirationDate=null;
    newViolation.referenceID=null;
    newViolation.violationPoints=null;
    newViolation.violationDefinitionId=null;
    newViolation.classification=null;
    newViolation.type=null;
    newViolation.description='';
    newViolation.points=null;
    newViolation.locationId=null;
    newViolation.locationName=null;
    newViolation.siteId=null;
    newViolation.siteName=null;
    newViolation.violationComment=null;
    this.driverViolation.push(newViolation);
    this.cdr.detectChanges();

    setTimeout(()=>{this.disabledEnabledElements(this.isEditable,"*", document.querySelector('#tableLevel'));},50);
  }

  deleteViolation(violationID: number, index: number)
  {
    var row =document.querySelector('#violation_date'+index.toString()).parentElement.parentElement;
    row.setAttribute('style','display:none');
    row.setAttribute('deleted','1');
    row =document.querySelector('#points_expiration_date'+index.toString()).parentElement.parentElement;
    row.setAttribute('style','display:none');
    row.setAttribute('deleted','1');

    this.driverViolation[index].violationDate=new Date(Date.now()).toJSON();
    this.driverViolation[index].violationTime='12:00:00';
    this.driverViolation[index].fakeViolationTime='12:00';
    this.driverViolation[index].violationPoints=0;
    this.driverViolation[index].violationDefinitionId=0;
    this.driverViolation[index].points=0;
    this.driverViolation[index].locationId=0;
    this.driverViolation[index].locationTypeId =0;
    this.driverViolation[index].siteId=0;
    this.driverViolation[index].pointsExpirationDate=new Date(Date.now()).toJSON();
    this.driverViolation[index].violationDefinitionId= (0-violationID);
  }

  ResetViolation(tableRef)
  {
    this.driverViolation=[];
    if (this.canAccessRestrictedSafetyApis)
      this._getDriverViolations();
  }

  ChangeViolationPoints(){
    if (this.driver.status_id!=2)
     this._setTotalViolationPoints();
  }

  private _setTotalViolationPoints()
  {
    if (this.driverViolation!=undefined){
      this.totalViolationPoints =0;
      this.driverViolation.forEach(dv=>{
        var vDate = new Date(dv.pointsExpirationDate);
        var currentDate = new Date();
        var m = vDate.getMonth();
        var d = vDate.getDate();
        var y = vDate.getFullYear();
        var newDate = new Date(y,m,d);

        if (newDate> currentDate){
          this.totalViolationPoints += +dv.violationPoints;
        }
        if (this.totalViolationPoints>=12){
          this.driver.status_id=3; // suspended since total points exceed 12 points
        }
        else{
          this.driver.status_id=1;
        }
      });
    }
  }

  // Accident portion
  AddAccident(tableRef)
  {
    window.location.href="#/accidentDetail/person/"+this.driver.personID;
  }

  ResetAccident(tableRef)
  {
    this.accidents=[];
    if (this.canAccessRestrictedSafetyApis)
      this._getDriverAccidents();
  }

  deleteAccident(accidentId: number, index: number)
  {
    var row =document.querySelector('#accident_date'+index.toString()).parentElement.parentElement;
    row.setAttribute('style','display:none');
    row.setAttribute('deleted','1');

    this.accidents[index].accidentDate=new Date(Date.now()).toJSON();
    this.accidents[index].classification='';
    this.accidents[index].causation='';
    this.accidents[index].locationId=0;
    this.accidents[index].locationTypeId =0;
    this.accidents[index].siteId=0;
    this.accidents[index].accidentId= (0-accidentId);
  }

  doLookupFields(fieldName) {
    if (fieldName == 'employeetypes') {
      this.employeeTypeService.getAllEmployeeTypes().subscribe(value => {
          this.employeeTypes = value;
          this.cdr.detectChanges();
        },
        err => {
          console.log(err);
          alert(err);
        },
        () => {
        }
      );
    }
    if (fieldName == 'trainingsites') {
      this.siteService.getAllSites().subscribe(value => {
          this.trainingsites = value;
          if (!this.isSuperAdmin) {
            this.availableRoles.forEach(x => {
              let siteCode = x.substr(x.lastIndexOf('_') + 1);
              if (value.find(v => v.siteCode === siteCode))
                this.availableSites.push(value.find(v => v.siteCode === siteCode).siteId);
            });
          }
          this.cdr.detectChanges();
        },
        err => {
          console.log(err);
          alert(err);
        },
        () => {
        }
      );
    }

    if (fieldName == 'levelsites') {
      this.siteService.getAllSites().subscribe(value => {
          this.levelsites = value;
          this.cdr.detectChanges();
        },
        err => {
          console.log(err);
          alert(err);
        },
        () => {
        }
      );
    }
    if (fieldName == 'endorsementsites') {
      this.siteService.getAllSites().subscribe(value => {
          this.endorsementsites = value;
          this.cdr.detectChanges();
        },
        err => {
          console.log(err);
          alert(err);
        },
        () => {
        }
      );
    }
    if (fieldName == 'regions') {
      this.regionService.getAll().subscribe(regions => {
          this.regions = regions;
          this.cdr.detectChanges();
        },
        err => {
          console.log(err);
          alert(err);
        },
        () => {
        });
    }
    if (fieldName == 'violationsites') {
      this.siteService.getAllSites().subscribe(value => {
          this.violationsites = value;
          this.violationsites.forEach(x=>{
            let textLength = 30 - x.siteCode.length;
            let fillEmptyField = " ";
            for (var i = 0; i < textLength; i++)
              fillEmptyField += " ";
            x.siteCodeAndName = x.siteCode + decodeURI(fillEmptyField.replace(/ /g, "%C2%A0")) + x.siteName;
          });
          this.cdr.detectChanges();
        },
        err => {
          console.log(err);
        },
        () => {
        }
      );
    }
    if (fieldName=='locationTypes'){
      this.locationTypeService.getAll().subscribe(value => {
          this.locationTypes = value;
          this.cdr.detectChanges();
        },
        err => {
          console.log(err);
        },
        () => {
        }
      );
    }
    if (fieldName=='locations'){
      this.locationService.getAll().subscribe(value => {
          this.locations = value;
          if(this.driverViolation.length>0){
            this.driverViolation.forEach(x=> this.MasterViolationLocations.push(this.locations));
          }
          this.cdr.detectChanges();
        },
        err => {
          console.log(err);
        },
        () => {
          this.driverViolation.forEach(x=>{
            x.locationTypeId = this.locations.find(l=>l.locationId == x.locationId).locationTypeId
          });

        }
      );
    }
    if (fieldName == 'course') {
      this.trainingService.getAllTraining().subscribe(value => {
          this.courses = value;
          this.courses.forEach(x=> {
            let textLength = 30 - x.courseNumber.length;
            let fillEmptyField = " ";
            for (var i = 0; i < textLength; i++)
              fillEmptyField += " ";
            x.courseNumberAndName = x.courseNumber + decodeURI(fillEmptyField.replace(/ /g, "%C2%A0")) + x.courseName;
          });
          this.cdr.detectChanges();
        },
        err => {
          console.log(err);
          alert(err);
        },
        () => {
          this.spinnerService.hide();
        }
      );
    }
    if (fieldName == 'endorsement') {
      this.endorsementService.getAllEndorsements().subscribe(value => {
          this.endorsements = value;
          this.endorsements.forEach(x=> {
            let textLength = Math.max(5, 50 - x.endorsementName.length);
            let fillEmptyField = " ";
            for (var i = 0; i < textLength; i++)
              fillEmptyField += " ";
            x.endorsementNameAndDesc = x.endorsementName + decodeURI(fillEmptyField.replace(/ /g, "%C2%A0")) + x.endorsementDesc;
          });
          this.cdr.detectChanges();
        },
        err => {
          console.log(err);
          alert(err);
        },
        () => {
        }
      );
    }
    if (fieldName == 'govEndorsement') {
      this.governmentEndorsementService.getAll().subscribe(
        value => {
          this.govEndorsements = value;
          this.cdr.detectChanges();
        },
        err => {
          console.log(err);
          alert(err);
        },
        () => {
        }
      );
    }

    if (fieldName === 'licenseTypes') {
      this.licenseTypeService.getAll().subscribe(
        value => {
          this.licenseTypes = value;
          this.cdr.detectChanges();
        },
        err => {
          console.log(err);
          alert(err);
        },
        () => { }
      );
    }

    if (fieldName == 'drivinglevel') {
      this.drivingLevelService.getAllDrivingLevels().subscribe(value => {
          this.drivingLevels = value;
          this.drivingLevels.forEach(x=> {
            let textLength = Math.max(5, 50 - x.drivingLevelName.length);
            let fillEmptyField = " ";
            for (var i = 0; i < textLength; i++)
              fillEmptyField += " ";
            x.levelNameAndDesc = x.drivingLevelName + decodeURI(fillEmptyField.replace(/ /g, "%C2%A0")) + x.description;
          });
          this.cdr.detectChanges();
        },
        err => {
          console.log(err);
          alert(err);
        },
        () => {

        }
      );
    }
    //violationDefinitions
    if (fieldName == 'violationDefinitions') {
      this.violationDefinitionService.getSorted().subscribe(value => {
          this.violationDefinitions = value;
          this.violationDefinitions.forEach(x=> {
            // Keep spacing similar to earlier behavior; avoid excessive first-column gap.
            let textLength = Math.max(3, 20 - x.classification.length);
            let fillEmptyField = " ";
            for (var i = 0; i < textLength; i++)
              fillEmptyField += " ";

            // Keep points column fixed-width (2 chars) so type/description columns stay aligned.
            const pointsText = String(x.points).padStart(2, ' ').replace(/ /g, '\u00A0');
            x.classificationAndDetail = x.classification + decodeURI(fillEmptyField.replace(/ /g, "%C2%A0")) + pointsText + ' | ' + x.type + ' | ' + x.description;
          });
          this.cdr.detectChanges();
        },
        err => {
          console.log(err);
          alert(err);
        },
        () => {

        }
      );
    }

  }

  disabledEnabledElements(enabled: boolean, tagName: string, topObject)
  {
    var all = topObject.querySelectorAll(tagName);

    for (var i = 0, max = all.length; i < max; i++) {
      if (enabled) {
        this.loop(all[i], 'disabled', '');
        if (all[i].tagName=='GM-DATEPICKER' || all[i].tagName=='SELECT') {
          if (all[i].parentNode.getElementsByTagName('INPUT').length>0) {
            all[i].parentNode.getElementsByTagName('INPUT')[0].outerHTML = "";
          }
          if (all[i].tagName=='GM-DATEPICKER')
            all[i].removeAttribute('class');
        }
      }
      else {
        this.loop(all[i],'disabled', 'disabled');
        if (all[i].tagName=='GM-DATEPICKER' || all[i].tagName=='SELECT') {
          if (all[i].parentNode.getElementsByTagName('INPUT').length>0) {
            all[i].parentNode.getElementsByTagName('INPUT')[0].removeAttribute("style");
          }
          all[i].outerHTML = "";
        }
      }

    }
  }

  updateCourseDescription(obj)
  {
    var value = (<HTMLSelectElement>document.getElementById(obj.srcElement.id)).value;
    var courseName = this.courses.find(x=>x.trainingCourseId==value).courseName;
    document.getElementById(obj.srcElement.id.replace('course_name','description')).innerHTML=courseName;

  }

  updateEndorsementDescription(obj)
  {
    var value = (<HTMLSelectElement>document.getElementById(obj.srcElement.id)).value;
    var endorsementDesc = this.endorsements.find(x=>x.endorsementId==value).endorsementDesc;
    document.getElementById(obj.srcElement.id.replace('endorsement','endorsement_description')).innerHTML=endorsementDesc;
  }
  updateDriverLevelName(obj){
    var value = (<HTMLSelectElement>document.getElementById(obj.srcElement.id)).value;
    var driverLevelDescription = this.drivingLevels.find(x=>x.drivingLevelId==value).drivingLevelDesc;
  }
  updateViolationDefinition(obj,index:number){
    var value = (<HTMLSelectElement>document.getElementById(obj.srcElement.id)).value;
    var violationDesc = this.violationDefinitions.find(x=>x.violationDefinitionId==value).description;
    var violationType = this.violationDefinitions.find(x=>x.violationDefinitionId==value).type;
    var violationPoints = this.violationDefinitions.find(x=>x.violationDefinitionId==value).points;
    document.getElementById(obj.srcElement.id.replace('violation_definition','violation_definition_desc')).title = violationDesc;
    document.getElementById(obj.srcElement.id.replace('violation_definition','violation_definition_desc')).innerHTML=violationDesc.substr(0,15) + "...";
    document.getElementById(obj.srcElement.id.replace('violation_definition','violation_definition_type')).innerHTML=violationType;
    this.driverViolation[index].violationPoints= violationPoints;
    this.ChangeViolationPoints();
  }

  changeDriverStatus(statusId, obj)
  {
    if (this.isSuperAdmin) {
      if (statusId != undefined) {
        if (statusId == 1)
          this.driver.status_id = 2;
        else
          this.driver.status_id = 1;
      }
      else
        this.driver.status_id = 1;
    }
  }

  setOriginalSiteId(siteId:number){
    this.originalSiteId = siteId;
  }

  changeSite(obj,item: Site,index:number){
    if (!this.isSuperAdmin && !this.availableSites.find(x=>x==obj.srcElement.value)) {
      alert('You do not have permission to change to this site.');
      obj.srcElement.value= this.originalSiteId;
      item.siteId = this.originalSiteId;
    }
    else if (obj.srcElement.id.includes('violation_site')){
      this.MasterViolationLocations[index] = [];
      this.driverViolation[index].locationTypeId = null;
    }
  }

  reStoreFullSiteName(obj,siteId:number,index:number){
    $("#violation_site" + index +" option:selected").text(this.violationsites.find(x=>x.siteId==siteId).siteName);
  }

  changeLocationType(obj,locationTypeId:number,index:number){
    this.MasterViolationLocations[index]=null;
    this.driverViolation[index].locationTypeId=locationTypeId;
    this.locationService.search(this.driverViolation[index].siteId,locationTypeId).subscribe(locs=>{
      if (locs.length>0){
        this.MasterViolationLocations[index]=locs;
        this.driverViolation[index].locationId = this.MasterViolationLocations[index][0].locationId;
      }
    },(error)=>{
      this.driverViolation[index].locationId=null;

      alert(error.error.errorCode +" : " + error.error.errorMessage);
    },()=>{ });
  }

  loop(node, attributeName:string, attributeValue: string) {
    // do some thing with the node here
    if (attributeValue.length>0 && attributeName.length>0) {
      node.setAttribute(attributeName, attributeValue);
    }
    var nodes = node.childNodes;
    for (var i = 0; i < nodes.length; i++) {
      if (!nodes[i]) {
        continue;
      }

      if (nodes[i].childNodes.length > 0) {
        this.loop(nodes[i],attributeName, attributeValue);
      }
    }
  }

  goBack(): void {
    this.location.back();
  }

  newDriver(): void {
    this.driver = new Driver();
  }
}
